// KL Dobor zrodla swiatla (04.11.2026): /pages/dobor-zrodla-swiatla, sekcja sections/kl-dobor.liquid.
// 1) wyszukiwanie lampy (combobox): /search/suggest.json (nazwa, SKU, EAN) + dla kodow z cyfra /search?view=konfig-szyn-dane
//    (pokazuje tez niedostepne, dokladny SKU na poczatku); wklejony link /products/<handle> otwiera lampe od razu.
// 2) dane lampy: /products/<h>?view=dobor-dane (metapola + custom.pasujace_zarowki), katalog zarowek
//    /collections/zarowki-led?view=dobor-dane (pobierany raz, dopiero po wyborze lampy).
// 3) dodanie do koszyka: POST /cart/add.js z sekcjami koszyka + zdarzenie cart:update (jak kl-zs.js), nasluch na window.
(() => {
  if (window.__klDb) return;
  window.__klDb = true;

  const box = document.querySelector('[data-kl-db]');
  if (!box) return;
  const inp = box.querySelector('[data-kl-db-q]');
  const lista = box.querySelector('[data-kl-db-lista]');
  const status = box.querySelector('[data-kl-db-status]');
  const wynik = box.querySelector('[data-kl-db-wynik]');
  const wyczysc = box.querySelector('[data-kl-db-wyczysc]');

  const RE_ZRODLO = /żarówk|świetlówk|tuba led|źródło światła|^reflektor( led)?$/i;
  const RE_DEKOR = /\b(G125|G200|A160|B125|T180|S200|R125|UFO|SMART|WI-?FI)\b/i;
  const BARWY = [
    { k: 'wszystkie', t: 'Wszystkie' },
    { k: '2700', t: '2700 K', o: 'bardzo ciepła' },
    { k: '3000', t: '3000 K', o: 'ciepła biała' },
    { k: '4000', t: '4000 K', o: 'neutralna' },
    { k: '6500', t: '6500 K', o: 'zimna' },
  ];
  const NA_START = 4;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const zl = (gr) => (Number(gr || 0) / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  const liczba = (s) => { const n = parseFloat(String(s || '').replace(',', '.').replace(/[^\d.]/g, '')); return Number.isFinite(n) ? n : 0; };
  const szerMm = (s) => { const n = liczba(s); if (!n) return 0; return n < 30 ? Math.round(n * 100) / 10 : n; };
  const grupa = (k) => { const n = liczba(k); if (!n || n < 1000) return ''; if (n <= 2700) return '2700'; if (n <= 3500) return '3000'; if (n <= 5000) return '4000'; return '6500'; };
  const pkt = (n) => (n === 1 ? 'punkt świetlny' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) ? 'punkty świetlne' : 'punktów świetlnych');
  const szt = (n) => n + ' szt.';
  const normGw = (g) => { const x = String(g || '').trim().toUpperCase().replace(/\s+/g, ' '); return x === 'GU10' ? 'GU10 R50' : x; };
  const sekcje = () => Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((e) => e.dataset.sectionId)));

  // ── wyszukiwanie ────────────────────────────────────────────────
  let timer = 0, kontroler = null, opcje = [], aktywna = -1, ostatnieQ = '';
  const cache = new Map();

  function zamknijListe() {
    lista.hidden = true;
    inp.setAttribute('aria-expanded', 'false');
    inp.removeAttribute('aria-activedescendant');
    aktywna = -1;
  }

  function uchwytZLinku(q) {
    const m = String(q).match(/\/products\/([a-z0-9][a-z0-9\-_%]*)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  async function szukaj(q) {
    if (cache.has(q)) return cache.get(q);
    if (kontroler) kontroler.abort();
    kontroler = new AbortController();
    const sig = kontroler.signal;
    const u = new URL('/search/suggest.json', location.origin);
    u.searchParams.set('q', q);
    u.searchParams.set('resources[type]', 'product');
    u.searchParams.set('resources[limit]', '10');
    u.searchParams.set('resources[options][unavailable_products]', 'last');
    u.searchParams.set('resources[options][fields]', 'title,variants.sku,variants.barcode,vendor,product_type');
    const zadania = [fetch(u, { signal: sig }).then((r) => r.json()).then((d) => ((d.resources || {}).results || {}).products || []).catch(() => [])];
    const kod = /\d/.test(q) && q.length >= 3;
    if (kod) {
      const s = new URL('/search', location.origin);
      s.searchParams.set('type', 'product');
      s.searchParams.set('view', 'konfig-szyn-dane');
      s.searchParams.set('options[fields]', 'variants.sku,variants.barcode,title');
      s.searchParams.set('options[unavailable_products]', 'last');
      s.searchParams.set('options[prefix]', 'last');
      s.searchParams.set('q', q);
      zadania.push(fetch(s, { signal: sig }).then((r) => r.json()).then((d) => d.p || []).catch(() => []));
    }
    const [pred, kody = []] = await Promise.all(zadania);
    const qn = q.trim().toLowerCase();
    const mapa = new Map();
    const dodajP = (h, o) => { if (!mapa.has(h)) mapa.set(h, o); else Object.assign(mapa.get(h), Object.fromEntries(Object.entries(o).filter(([, v]) => v))); };
    // 1. dokladny kod (SKU) z wyszukiwarki pelnej
    kody.filter((x) => String(x.s || '').toLowerCase() === qn).forEach((x) => dodajP(x.h, { h: x.h, t: x.t, vn: x.vn, ty: x.ty, s: x.s, i: x.i, a: x.a, exact: true }));
    pred.forEach((p) => dodajP(p.handle, { h: p.handle, t: p.title, vn: p.vendor, ty: p.type, i: p.image || (p.featured_image || {}).url, a: p.available }));
    kody.forEach((x) => dodajP(x.h, { h: x.h, t: x.t, vn: x.vn, ty: x.ty, s: x.s, i: x.i, a: x.a }));
    const wynikiQ = Array.from(mapa.values()).filter((p) => !RE_ZRODLO.test(p.ty || '') || /lamp|oprawa|kinkiet|plafon|reflektorek/i.test(p.ty || '')).slice(0, 8);
    cache.set(q, wynikiQ);
    return wynikiQ;
  }

  function pokazListe(wyn, q) {
    opcje = wyn;
    aktywna = -1;
    if (!wyn.length) {
      lista.innerHTML = '';
      zamknijListe();
      status.textContent = `Nie znaleźliśmy lampy dla „${q}”. Sprawdź kod albo wpisz nazwę modelu.`;
      return;
    }
    lista.innerHTML = wyn.map((p, n) => `
      <li id="kl-db-op-${n}" class="kl-db__op" role="option" aria-selected="false" data-n="${n}">
        ${p.i ? `<img src="${esc(/width=/.test(p.i) ? p.i : p.i + (String(p.i).includes('?') ? '&' : '?') + 'width=96')}" alt="" width="48" height="48" loading="lazy">` : '<span class="kl-db__op-brak" aria-hidden="true"></span>'}
        <span class="kl-db__op-t"><b>${esc(p.t)}</b><small>${esc([p.vn, p.s ? 'kod ' + p.s : '', p.a === false ? 'chwilowo niedostępna' : ''].filter(Boolean).join(' · '))}</small></span>
      </li>`).join('');
    lista.hidden = false;
    inp.setAttribute('aria-expanded', 'true');
    status.textContent = `${wyn.length} ${wyn.length === 1 ? 'lampa' : wyn.length < 5 ? 'lampy' : 'lamp'}. Strzałki w dół i w górę wybierają, Enter otwiera.`;
  }

  function ustawAktywna(n) {
    const el = lista.querySelectorAll('.kl-db__op');
    if (!el.length) return;
    aktywna = (n + el.length) % el.length;
    el.forEach((o, i) => o.setAttribute('aria-selected', i === aktywna ? 'true' : 'false'));
    inp.setAttribute('aria-activedescendant', el[aktywna].id);
    el[aktywna].scrollIntoView({ block: 'nearest' });
  }

  inp.addEventListener('input', () => {
    const q = inp.value.trim();
    wyczysc.hidden = !inp.value;
    clearTimeout(timer);
    const h = uchwytZLinku(q);
    if (h) { zamknijListe(); otworzLampe(h); return; }
    if (q.length < 2) { zamknijListe(); status.textContent = ''; return; }
    timer = setTimeout(async () => {
      ostatnieQ = q;
      status.textContent = 'Szukam...';
      const wyn = await szukaj(q).catch(() => []);
      if (ostatnieQ !== q || inp.value.trim() !== q) return;
      pokazListe(wyn, q);
    }, 220);
  });

  inp.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); if (lista.hidden && opcje.length) { lista.hidden = false; inp.setAttribute('aria-expanded', 'true'); } ustawAktywna(aktywna + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); ustawAktywna(aktywna - 1); }
    else if (e.key === 'Enter') {
      if (!lista.hidden && opcje.length) { e.preventDefault(); wybierz(aktywna >= 0 ? aktywna : 0); }
    } else if (e.key === 'Escape') { if (!lista.hidden) { e.preventDefault(); zamknijListe(); } }
  });
  lista.addEventListener('mousedown', (e) => e.preventDefault());
  lista.addEventListener('click', (e) => { const o = e.target.closest('.kl-db__op'); if (o) wybierz(Number(o.dataset.n)); });
  inp.addEventListener('blur', () => setTimeout(zamknijListe, 150));
  wyczysc.addEventListener('click', () => { inp.value = ''; wyczysc.hidden = true; zamknijListe(); status.textContent = ''; inp.focus(); });

  function wybierz(n) {
    const p = opcje[n];
    if (!p) return;
    inp.value = p.t;
    zamknijListe();
    otworzLampe(p.h);
  }

  // ── dane ────────────────────────────────────────────────────────
  let katalogP = null;
  function katalog() {
    if (!katalogP) {
      katalogP = (async () => {
        const wsz = [];
        for (let s = 1; s <= 4; s++) {
          const d = await fetch(`/collections/zarowki-led?view=dobor-dane&page=${s}`).then((r) => r.json());
          wsz.push(...(d.p || []));
          if (!d.pages || s >= d.pages) break;
        }
        return wsz;
      })().catch((e) => { katalogP = null; throw e; });
    }
    return katalogP;
  }

  let stan = null;

  async function otworzLampe(h) {
    status.textContent = 'Wczytuję dane lampy...';
    wynik.hidden = false;
    wynik.setAttribute('aria-busy', 'true');
    wynik.innerHTML = '<div class="kl-db__lad" aria-hidden="true"><span></span><span></span><span></span></div>';
    try {
      const r = await fetch(`/products/${encodeURIComponent(h)}?view=dobor-dane`);
      if (!r.ok) throw new Error('brak');
      const lampa = await r.json();
      const gw = gwintyLampy(lampa);
      const potrzebne = gw.length > 0;
      const kat = potrzebne ? await katalog().catch(() => []) : [];
      stan = { lampa, gw, kat, barwa: null, pelne: {} };
      stan.barwa = domyslnaBarwa();
      render();
      status.textContent = `Lampa: ${lampa.t}`;
      try { const u = new URL(location.href); u.searchParams.set('lampa', h); history.replaceState(null, '', u); } catch (e) {}
      wynik.focus({ preventScroll: true });
      if (wynik.getBoundingClientRect().top < 0 || wynik.getBoundingClientRect().top > innerHeight * 0.6) wynik.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    } catch (e) {
      wynik.innerHTML = '<p class="kl-db__info kl-db__info--blad">Nie udało się wczytać tej lampy. Odśwież stronę albo wyszukaj ją ponownie.</p>';
      status.textContent = 'Nie udało się wczytać lampy.';
    } finally {
      wynik.removeAttribute('aria-busy');
    }
  }

  // gwinty lampy, ktore potrzebuja zarowki: z custom.pasujace_zarowki (rozstrzygniete przez kl_pasujace_zarowki.py),
  // a gdy go brak - z metapola gwintow (bez LED zintegrowanego)
  function gwintyLampy(l) {
    const out = [];
    const dodaj = (g, il) => { const n = normGw(g); if (!n || /LED|ZINTEGR/.test(n)) return; const o = out.find((x) => x.g === n); if (o) { o.il = Math.max(o.il, il || 0); } else out.push({ g: n, il: il || 0, rek: [] }); };
    (l.pz || []).forEach((p) => { dodaj(p.gw, p.il); const o = out.find((x) => x.g === normGw(p.gw)); if (o) o.rek.push(p.z); });
    l.zPz = out.length > 0;
    if (!out.length && !l.zrodlo) {
      (l.gw || []).forEach((g) => dodaj(g, 0));
      if (!out.length && l.zr && !/zintegr|led$/i.test(l.zr)) String(l.zr).split(/[\/+,]| i /).forEach((g) => dodaj(g, 0));
    }
    // ilosc: z metapola zarowek, dalej konfiguracja "5 x E14 + 4 x E27", dalej punkty swietlne (jeden gwint)
    out.forEach((o) => {
      if (o.il > 0) return;
      const m = String(l.konf || '').toUpperCase().match(new RegExp('(\\d+)\\s*X\\s*' + o.g.split(' ')[0].replace('.', '\\.')));
      if (m) o.il = Number(m[1]);
      else if (out.length === 1 && l.pkt > 0) o.il = l.pkt;
      else o.il = 1;
    });
    return out;
  }

  function stanLampy(l) {
    const zaw = String(l.zaw || '').toLowerCase();
    const ledTylko = (l.gw || []).some((g) => /zintegr/i.test(g)) || /zintegr/i.test(l.zr || '');
    if (l.zrodlo) return 'zrodlo';
    if (l.zPz) return ledTylko ? 'mieszana' : 'bez';
    if (!stan.gw.length) return ledTylko ? 'led' : 'brak';
    if (/^tak|^zawiera|w zestawie|w komplecie/.test(zaw) && !/nie/.test(zaw)) return 'zestaw';
    return 'niepewne';
  }

  function listaDla(o) {
    const l = stan.lampa;
    const rek = o.rek.filter((z) => z && z.a);
    const handle = new Set(rek.map((z) => z.h));
    const szerRek = rek.map((z) => szerMm(z.sz)).filter(Boolean);
    const waskie = /^G9|^G4/.test(o.g) && szerRek.length ? Math.max(...szerRek) : 0;
    // gwint z metapola zarowki + kontrola w tytule (dane bywaja bledne, np. AR111 G53 opisana jako GX53); 12 V tylko do lamp 12 V
    const baza = o.g.split(' ')[0].replace('.', '\\.');
    const reTyt = new RegExp('(^|[^A-Z0-9])' + baza + '([^A-Z0-9]|$)', 'i');
    const lampa12 = /^(G4|G53|GU5|MR16|GU4)/.test(o.g);
    const pasuje = (z) => (z.g || []).map(normGw).includes(o.g) && reTyt.test(z.t || '') && (lampa12 || !/\b12\s?V\b/i.test(z.t || ''));
    const alt = stan.kat.filter((z) => z.a && !handle.has(z.h) && pasuje(z)
      && !(l.mw > 0 && z.w > 0 && z.w > l.mw)
      && !(waskie && (!szerMm(z.sz) || szerMm(z.sz) > waskie)));
    alt.sort((a, b) => (RE_DEKOR.test(a.t) - RE_DEKOR.test(b.t)) || ((b.vn === 'Nowodvorski') - (a.vn === 'Nowodvorski')));
    return rek.map((z) => Object.assign({}, z, { pol: true })).concat(alt);
  }

  function domyslnaBarwa() {
    for (const o of stan.gw) { const z = o.rek.find((x) => x && x.a && grupa(x.k)); if (z) return grupa(z.k); }
    for (const o of stan.gw) { const z = listaDla(o).find((x) => grupa(x.k) === '3000'); if (z) return '3000'; }
    return 'wszystkie';
  }

  // ── widok ───────────────────────────────────────────────────────
  const IKONA_OK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  const IKONA_INFO = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0 0 12 3z"/></svg>';

  function paramy(l) {
    const tr = stan.gw.length ? stan.gw.map((o) => o.g).join(', ') : (l.zr || (l.gw || []).join(', ') || 'brak danych');
    const punkty = stan.gw.length ? stan.gw.map((o) => (stan.gw.length > 1 ? `${o.il} x ${o.g}` : String(o.il))).join(' + ') : (l.pkt > 0 ? String(l.pkt) : '-');
    const moc = l.mm || (l.mw ? l.mw + ' W' : '-');
    const st0 = stanLampy(l);
    const zs = { bez: 'do kupienia osobno', mieszana: 'LED wbudowany + gniazda na żarówki', led: 'LED zintegrowany', zestaw: 'żarówki w zestawie', niepewne: 'sprawdź w opisie lampy', brak: 'brak danych', zrodlo: 'to jest źródło światła' }[st0];
    const p = [['Trzonek', st0 === 'led' ? 'brak (LED)' : tr], ['Punkty świetlne', punkty], [st0 === 'led' ? 'Moc' : 'Maks. moc na punkt', moc], ['Stopień ochrony', l.ip || '-'], ['Źródło światła', zs]];
    return `<dl class="kl-db__par">${p.map(([a, b]) => `<div><dt>${a}</dt><dd>${esc(b)}</dd></div>`).join('')}</dl>`;
  }

  function wiersz(z, il, gid, n) {
    const ile = Math.max(1, Math.min(il || 1, z.mx || 99));
    const k = liczba(z.k), sz = szerMm(z.sz), lm = liczba(z.lm);
    const meta = [k ? k + ' K' : '', z.w ? String(z.w).replace('.', ',') + ' W' : '', lm ? Math.round(lm) + ' lm' : '', sz ? 'szer. ' + String(sz).replace('.', ',') + ' mm' : ''].filter(Boolean).join(' · ');
    const id = `kl-db-il-${gid}-${n}`;
    return `<li class="kl-db__poz" data-kl-db-poz data-id="${z.v}" data-cena="${z.c}" data-max="${z.mx || 99}" data-nazwa="${esc(z.n || z.t)}">
      <img class="kl-db__poz-img" src="${esc(z.i || '')}" alt="" width="64" height="64" loading="lazy">
      <div class="kl-db__poz-op">
        ${z.pol ? '<span class="kl-db__odz">Polecana</span>' : ''}
        <a class="kl-db__poz-n" href="${esc(z.u)}">${esc(z.n || z.t)}</a>
        <span class="kl-db__poz-m">${esc(meta)}</span>
        <span class="kl-db__poz-c" data-kl-db-cena>${ile > 1 ? `${ile} x ${zl(z.c)} = <b>${zl(z.c * ile)}</b>` : `<b>${zl(z.c)}</b>`}</span>
      </div>
      <div class="kl-db__poz-ak">
        <div class="kl-db__ile" role="group" aria-label="Liczba sztuk: ${esc(z.n || z.t)}">
          <button type="button" class="kl-db__krok" data-kl-db-krok="-1" aria-label="Mniej sztuk"${ile <= 1 ? ' disabled' : ''}><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>
          <label class="kl-db__sr" for="${id}">Liczba sztuk</label>
          <input id="${id}" class="kl-db__liczba" type="number" inputmode="numeric" min="1" max="${z.mx || 99}" step="1" value="${ile}" data-kl-db-ilosc>
          <button type="button" class="kl-db__krok" data-kl-db-krok="1" aria-label="Więcej sztuk"${ile >= (z.mx || 99) ? ' disabled' : ''}><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>
        </div>
        <button type="button" class="kl-db__dodaj" data-kl-db-dodaj aria-label="Dodaj do koszyka: ${esc(z.n || z.t)}, ${szt(ile)}"><span>Dodaj do koszyka</span></button>
      </div>
      <p class="kl-db__blad" data-kl-db-blad role="alert" hidden></p>
    </li>`;
  }

  function render() {
    const l = stan.lampa;
    const st = stanLampy(l);
    let h = `<div class="kl-db__lampa-k">
      ${l.i ? `<img src="${esc(l.i)}" alt="" width="96" height="96">` : ''}
      <div class="kl-db__lampa-op">
        <span class="kl-db__lampa-m">${esc([l.vn, l.s ? 'kod ' + l.s : ''].filter(Boolean).join(' · '))}</span>
        <a class="kl-db__lampa-t" href="${esc(l.u)}">${esc(l.t)}</a>
      </div>
      <button type="button" class="kl-db__zmien" data-kl-db-zmien>Zmień lampę</button>
    </div>${paramy(l)}`;

    if (st === 'zrodlo') {
      h += `<p class="kl-db__info">${IKONA_INFO}<span>Ten produkt jest źródłem światła, nie lampą. Wyszukaj lampę, do której szukasz żarówki, albo <a href="${esc(l.u)}">zobacz tę żarówkę</a>.</span></p>`;
    } else if (st === 'led') {
      h += `<p class="kl-db__info kl-db__info--ok">${IKONA_OK}<span><b>Żarówka nie jest potrzebna.</b> Ta lampa ma zintegrowane źródło światła LED, świeci od razu po montażu.</span></p>`;
    } else if (st === 'brak') {
      h += `<p class="kl-db__info">${IKONA_INFO}<span>Nie mamy pewnych danych o trzonku tej lampy. <a href="/pages/kontakt">Napisz do nas</a>, a dobierzemy żarówkę, albo sprawdź trzonek w quizie <a href="#kl-db-trzonki">„Jaki mam trzonek?”</a>.</span></p>`;
    } else {
      if (st === 'zestaw') h += `<p class="kl-db__info kl-db__info--ok">${IKONA_OK}<span><b>Żarówki są w zestawie z lampą.</b> Poniżej pasujące żarówki na zapas albo w innej barwie.</span></p>`;
      if (st === 'niepewne') h += `<p class="kl-db__info">${IKONA_INFO}<span>Sprawdź w opisie lampy, czy żarówki są w zestawie. Te pasują do jej trzonka i mocy.</span></p>`;
      if (st === 'mieszana') h += `<p class="kl-db__info">${IKONA_INFO}<span>Część światła to wbudowany LED. Żarówki są potrzebne tylko do gniazd ${esc(stan.gw.map((o) => o.g).join(', '))}.</span></p>`;
      if (st === 'bez') h += `<p class="kl-db__info">${IKONA_INFO}<span><b>Lampa jest sprzedawana bez żarówek.</b> Liczba sztuk odpowiada liczbie punktów świetlnych, możesz ją zmienić.</span></p>`;
      const wsz = stan.gw.flatMap((o) => listaDla(o));
      const ile = (k) => (k === 'wszystkie' ? wsz.length : wsz.filter((z) => grupa(z.k) === k).length);
      h += `<fieldset class="kl-db__barwy"><legend>Barwa światła</legend><div class="kl-db__chipy">${BARWY.filter((b) => b.k === 'wszystkie' || ile(b.k) > 0 || b.k !== '6500').map((b) => {
        const n = ile(b.k);
        return `<label><input type="radio" name="kl-db-barwa" value="${b.k}"${stan.barwa === b.k ? ' checked' : ''}${n ? '' : ' disabled'}><span>${b.t}${b.o ? ` <small>${b.o}</small>` : ''} <em>${n}</em></span></label>`;
      }).join('')}</div></fieldset>`;
      stan.gw.forEach((o, gi) => {
        const pel = listaDla(o);
        const lst = stan.barwa === 'wszystkie' ? pel : pel.filter((z) => grupa(z.k) === stan.barwa);
        const pokaz = stan.pelne[o.g] ? lst : lst.slice(0, NA_START);
        h += `<div class="kl-db__gw"><h3 class="kl-db__h3">${esc(o.g)} <span>${o.il} ${pkt(o.il)}</span></h3>`;
        if (!lst.length) {
          h += `<p class="kl-db__pusto">Brak żarówek ${esc(o.g)} w tej barwie na stanie. Wybierz inną barwę${pel.length ? '' : ''} albo <a href="/search?q=${encodeURIComponent(o.g)}&type=product">zobacz wszystkie źródła ${esc(o.g)}</a>.</p>`;
        } else {
          h += `<ul class="kl-db__lst" role="list">${pokaz.map((z, n) => wiersz(z, o.il, gi, n)).join('')}</ul>`;
          if (lst.length > pokaz.length) h += `<button type="button" class="kl-db__wiecej" data-kl-db-wiecej="${esc(o.g)}">Pokaż więcej żarówek ${esc(o.g)} (${lst.length - pokaz.length})</button>`;
        }
        h += '</div>';
      });
    }
    wynik.innerHTML = h;
  }

  // ── zdarzenia w wyniku ──────────────────────────────────────────
  function odswiez(li) {
    const p = li.querySelector('[data-kl-db-ilosc]');
    const mx = Math.max(1, parseInt(li.dataset.max, 10) || 99);
    let n = parseInt(p.value, 10);
    if (!Number.isFinite(n) || n < 1) n = 1;
    n = Math.min(n, mx);
    p.value = n;
    li.querySelectorAll('[data-kl-db-krok]').forEach((b) => { b.disabled = b.dataset.klDbKrok === '-1' ? n <= 1 : n >= mx; });
    const c = Number(li.dataset.cena);
    li.querySelector('[data-kl-db-cena]').innerHTML = n > 1 ? `${n} x ${zl(c)} = <b>${zl(c * n)}</b>` : `<b>${zl(c)}</b>`;
    li.querySelector('[data-kl-db-dodaj]').setAttribute('aria-label', `Dodaj do koszyka: ${li.dataset.nazwa}, ${szt(n)}`);
    return n;
  }

  async function dodaj(btn) {
    const li = btn.closest('[data-kl-db-poz]');
    if (!li || btn.getAttribute('aria-busy') === 'true') return;
    const n = odswiez(li);
    const bl = li.querySelector('[data-kl-db-blad]');
    bl.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.remove('is-ok');
    btn.querySelector('span').textContent = 'Dodaję...';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(li.dataset.id), quantity: n }], sections: sekcje().join(','), sections_url: location.pathname }),
      });
      const dane = await r.json();
      if (!r.ok || dane.status) throw new Error(dane.description || dane.message || 'Nie udało się dodać do koszyka.');
      const koszyk = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
      const ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: koszyk, sourceId: 'kl-db', data: { source: 'kl-db', itemCount: koszyk.item_count, variantId: String(li.dataset.id), sections: dane.sections || {} } };
      document.dispatchEvent(ev);
      btn.classList.add('is-ok');
      btn.querySelector('span').textContent = `Dodano ${szt(n)}`;
      status.textContent = `Dodano do koszyka: ${li.dataset.nazwa}, ${szt(n)}.`;
      setTimeout(() => { btn.classList.remove('is-ok'); btn.querySelector('span').textContent = 'Dodaj do koszyka'; }, 3500);
    } catch (e) {
      bl.textContent = (e && e.message) || 'Nie udało się dodać do koszyka. Spróbuj ponownie.';
      bl.hidden = false;
      btn.querySelector('span').textContent = 'Dodaj do koszyka';
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  // nasluch na window w fazie capture (motyw KL lapie zdarzenia na document - pulapka quick-add)
  window.addEventListener('click', (e) => {
    const t = e.target && e.target.closest ? e.target : null;
    if (!t || !wynik.contains(t)) return;
    const krok = t.closest('[data-kl-db-krok]');
    if (krok) { const li = krok.closest('[data-kl-db-poz]'); const p = li.querySelector('[data-kl-db-ilosc]'); p.value = (parseInt(p.value, 10) || 1) + Number(krok.dataset.klDbKrok); odswiez(li); return; }
    const d = t.closest('[data-kl-db-dodaj]');
    if (d) { e.preventDefault(); e.stopPropagation(); dodaj(d); return; }
    const w = t.closest('[data-kl-db-wiecej]');
    if (w) { stan.pelne[w.dataset.klDbWiecej] = true; const g = w.dataset.klDbWiecej; render(); const h3 = Array.from(wynik.querySelectorAll('.kl-db__h3')).find((x) => x.textContent.startsWith(g)); if (h3) { const pz = h3.parentElement.querySelectorAll('[data-kl-db-dodaj]')[NA_START]; if (pz) pz.focus(); } return; }
    if (t.closest('[data-kl-db-zmien]')) { inp.focus(); inp.select(); box.scrollIntoView({ block: 'start' }); }
  }, true);
  wynik.addEventListener('change', (e) => {
    if (e.target.name === 'kl-db-barwa') {
      stan.barwa = e.target.value; render();
      const r = wynik.querySelector(`input[name="kl-db-barwa"][value="${stan.barwa}"]`); if (r) r.focus();
      const n = wynik.querySelectorAll('[data-kl-db-poz]').length;
      status.textContent = `Barwa ${stan.barwa === 'wszystkie' ? 'dowolna' : stan.barwa + ' K'}: ${n} ${n === 1 ? 'żarówka' : 'żarówek'} na liście.`;
    } else if (e.target.matches('[data-kl-db-ilosc]')) odswiez(e.target.closest('[data-kl-db-poz]'));
  });

  // ?lampa=<handle> (link z karty produktu) albo ?q=<tekst>
  const par = new URLSearchParams(location.search);
  if (par.get('lampa')) otworzLampe(par.get('lampa'));
  else if (par.get('q')) { inp.value = par.get('q'); inp.dispatchEvent(new Event('input')); }
})();
